export default __webpack_public_path__ + "static/media/logo.966edfc2.png";